// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D6Gw","placeholder":"styles_placeholder__2E3c4"};